

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"viewBox":"0 0 12 14"}, rest), ["\n  ", h('path', {"fill":"currentColor","fill-rule":"evenodd","d":"M6.004 0c2.386 0 5.118 1.425 5.828 4.615.78 3.508-1.305 6.45-3.192 8.298A3.785 3.785 0 0 1 5.998 14c-.947 0-1.9-.364-2.642-1.087C1.47 11.065-.616 8.116.171 4.608.88 1.425 3.612 0 5.998 0h.006Zm-.006.976c-1.861 0-4.254 1.01-4.887 3.847-.691 3.065 1.202 5.708 2.917 7.38a2.796 2.796 0 0 0 3.947 0c1.708-1.672 3.601-4.315 2.923-7.38-.64-2.838-3.039-3.847-4.9-3.847Zm0 2.402c1.363 0 2.476 1.126 2.476 2.519C8.474 7.29 7.361 8.409 6 8.409c-1.363 0-2.476-1.126-2.476-2.519 0-1.393 1.113-2.512 2.476-2.512Zm0 .976c-.83 0-1.515.69-1.515 1.543 0 .852.678 1.542 1.516 1.542s1.516-.69 1.516-1.542c0-.853-.685-1.543-1.516-1.543Z"}, []), "\n"]);
};

        